import { Typography, Select, Tag } from 'antd';
import { ROLES, PROVIDER_COLOR } from './users.constants';

/** 可直接編輯的 email（未設定時顯示灰字）。 */
export function UserEmail({ email, onChange, className }: { email: string | null; onChange: (v: string) => void; className?: string }) {
  return (
    <Typography.Text
      type={email ? undefined : 'secondary'}
      className={className}
      editable={{ tooltip: '編輯 email', onChange }}
    >
      {email || '未設定'}
    </Typography.Text>
  );
}

/** 登入方式標籤（逗號分隔字串）。 */
export function ProviderTags({ providers }: { providers: string | null }) {
  if (!providers) return <>—</>;
  return (
    <>
      {providers.split(',').map((x) => (
        <Tag key={x} color={PROVIDER_COLOR[x] ?? 'default'}>
          {x}
        </Tag>
      ))}
    </>
  );
}

/** 角色選擇（取第一個角色為目前值）。 */
export function RoleSelect({ roles, width, onChange }: { roles: string | null; width: number; onChange: (roleId: string) => void }) {
  return (
    <Select
      size="small"
      style={{ width }}
      value={roles?.split(',')[0]}
      placeholder="未指派"
      options={ROLES}
      onChange={onChange}
    />
  );
}
